import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NotificationRoutingModule } from './notification-routing.module';
import { ServicesComponent } from './services/services.component';
import { WhatsappConfigComponent } from './whatsapp-config/whatsapp-config.component';
import { SharedModule } from "../Shared/shared.module";
import { EmailConfigComponent } from './email-config/email-config.component';
import { DBConfigComponent } from './dbconfig/dbconfig.component';
import { SchedulersComponent } from './schedulers/schedulers.component';
import { HistoryComponent } from './history/history.component';
import { AlertsServiceDetailsComponent } from './services/alerts-service-details/alerts-service-details.component';
import { SendEmailComponent } from './send-email/send-email.component';
import { EmailTemplateComponent } from './email-template/email-template.component';
import { SmsConfigComponent } from './sms-config/sms-config.component';
import { SmsTemplateComponent } from './sms-template/sms-template.component';
import { WhatsappPagesModule } from './whatsapp-pages.module';


@NgModule({
  declarations: [
    ServicesComponent,
    WhatsappConfigComponent,
    EmailConfigComponent,
    DBConfigComponent,
    SchedulersComponent,
    HistoryComponent,
    AlertsServiceDetailsComponent,
    SendEmailComponent,
    EmailTemplateComponent,
    SmsConfigComponent,
    SmsTemplateComponent
  ],
  imports: [
    CommonModule,
    NotificationRoutingModule,
    SharedModule,
    WhatsappPagesModule,
],
exports:[
  SendEmailComponent
]
})
export class NotificationModule { }
